import { motion } from 'framer-motion';
import { addons, ui, fmt } from './pricingData';
import { buildWhatsAppLink } from '@/components/services/servicesData';

export default function PricingAddons({ lang }) {
  const tx = (o) => o?.[lang] || o?.en;
  return (
    <motion.section id="addons" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="py-14">
      <div className="text-center mb-12">
        <span className="text-xs font-medium tracking-[0.3em] uppercase text-primary">05</span>
        <h2 className="font-inter font-black text-3xl md:text-4xl tracking-[-0.02em] text-foreground mt-2 mb-3">{tx(addons.title)}</h2>
        <p className="text-muted-foreground">{tx(addons.subtitle)}</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {addons.items.map((a) => (
          <a key={a.name.en} target="_blank" rel="noopener noreferrer"
            href={buildWhatsAppLink(lang === 'es'
              ? `¡Hola, Jotunheims! Estoy interesado en el servicio "${tx(a.name)}" (Desde ${fmt(a.price)} USD).\n\n${tx(a.desc)}\n\nMe gustaría recibir más información para comenzar.`
              : `Hi Jotunheims! I'm interested in the "${tx(a.name)}" service (From ${fmt(a.price)} USD).\n\n${tx(a.desc)}\n\nI'd like more information to get started.`)}
            className="block rounded-2xl border border-border/50 bg-card/50 p-6 hover:border-primary/30 hover:-translate-y-1 transition-all duration-500 cursor-pointer">
            <div className="flex items-start justify-between gap-4 mb-2">
              <h3 className="font-inter font-bold text-foreground">{tx(a.name)}</h3>
              <div className="text-right shrink-0">
                <span className="block text-[10px] uppercase tracking-widest text-muted-foreground">{tx(ui.from)}</span>
                <span className="font-black text-xl text-primary">{fmt(a.price)}</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">{tx(a.desc)}</p>
          </a>
        ))}
      </div>
    </motion.section>
  );
}